import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link for internal navigation
import logo1 from "../../../assets/images/logo1.png";
import classes from "./styles.module.scss";
import Switch from "../../../components/switch";
import dopt from '../../../assets/pdf/Dopt_DG Sir_Office_Order.pdf';
import stateTrainingPolicy from '../../../assets/pdf/stateTrainingPolicy.pdf';
import ATI from '../../../assets/pdf/ListOfATIs.pdf';
import Act from '../../../assets/pdf/ACT.pdf';

const Footer = () => {
  const mapData = [
    {
      title: "Gaya",
      map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.9796737379966!2d84.97675897406423!3d24.761886049197393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32b0621fc9a87%3A0xef0bbbf59d09192f!2sBIPARD%20%5BGAYA%5D!5e0!3m2!1sen!2sin!4v1720242750580!5m2!1sen!2sin",
    },
    {
      title: "Patna",
      map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3599.0291597454166!2d85.04509927409543!3d25.570696616473732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed56275a98a277%3A0xe534cdccc4d1f734!2sBihar%20Institute%20of%20Public%20Administration%20%26%20Rural%20Development%2C%20WALMI%20Campus!5e0!3m2!1sen!2sin!4v1725363966620!5m2!1sen!2sin",
    }
  ];

  const [switchData, setSwitchData] = useState();
  const [activeTab, setActiveTab] = useState(0);
  useEffect(() => {
    setSwitchData(mapData?.[activeTab]);
  }, []);

  const handleSwitch = (index) => {
    setActiveTab(index);
    setSwitchData(mapData?.[index]);
  };

  return (
    <div className={classes.footer}>
      <div className={classes.wrap}>
        <div className={classes.part1}>
          <Link to="/"><img src={logo1} alt="logo" /></Link>
          <Link to="/"><h4>Bihar Institute of Public Administration & Rural Development</h4></Link>
          <div className={classes.icon}>
            <a href="https://www.youtube.com/@bipardgaya4894" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube"></i></a>
            <a href="https://twitter.com/BipardGaya" target="_blank" rel="noreferrer"><i className="fa-brands fa-x-twitter"></i></a>
            <a href="https://www.facebook.com/bipard/" target="_blank" rel="noreferrer"><i className="fa-brands fa-square-facebook"></i></a>
            <a href="https://www.instagram.com/bipard_gaya/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
            <a href="https://www.linkedin.com/company/bipard-bihar-institute-of-public-administration-rural-development-bipard-gaya/?viewAsMember=true" target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a>
          </div>
        </div>
        
        <div className={classes.exp}>
          <h4>Explore</h4>
          <a href="https://secc.gov.in/getSeccDataSummaryStateReport.htm/10" target="_blank" rel="noreferrer"><p>SECC-2011 Booklet</p></a>
          <a href={dopt} target="_blank" rel="noreferrer"><p>National Training Policy: DoPT</p></a>
          <a href={stateTrainingPolicy} target="_blank" rel="noreferrer"><p>State Training Policy</p></a>
          <a href={ATI} target="_blank" rel="noreferrer"><p>ATI's in India</p></a>
          <a href="https://bvm.bihar.gov.in/reportcard/" target="_blank" rel="noreferrer"><p>Bihar Report Card</p></a>
        </div>
        
        <div className={classes.quick}>
          <h4>Quick Links</h4>
          <Link to="/visitus"><p>Contact Us</p></Link>
          <a href={Act} target="_blank" rel="noreferrer"><p>RTPS Act</p></a>
          <a href="http://bpsm.bihar.gov.in/assets/Home.aspx?P1=3&P2=0&P3=79&P4=3" target="_blank" rel="noreferrer"><p>Assets Declaration</p></a>
          <a href="https://erp.bipard.co.in/citizen-survey/bihar-vision-document" target="_blank" rel="noreferrer"><p>Survey Form</p></a>
        </div>
        
        <div className={classes.locat}>
          <div className={classes.swt}>
            <h4>Location</h4>
            <Switch activeTab={activeTab} handleClick={handleSwitch} />
          </div>
          <div className={classes.mapcard}>
            <iframe
              title="map"
              src={switchData?.map}
              style={{ width: "300px", height: "200px", border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <div className={classes.copyright}>
      <p>&copy; Copyright owned by <b>BIPARD</b>, All Rights Reserved.</p>
      <p>Designed & Developed by&nbsp;<a href="https://codebuckets.in/" target='_blank' rel="noreferrer"> Codebucket Solutions Pvt. Ltd</a>.</p>
      </div>
    </div>
  );
};

export default Footer;
